import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-risk-assessment-report',
  templateUrl: './risk-assessment-report.component.html',
  styleUrls: ['./risk-assessment-report.component.scss']
})
export class RiskAssessmentReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
